import queryString from 'query-string'
import { usingGet, EMPTY_SUCCESS_RESPONSE } from '@ocean/api'
import { FilterUtils } from '@ocean/utils'
import { ActivityLogExternalFilterItems } from 'modules/activityLog/ActivityLog/types'

export const getActivityLog = (externalFilters: ActivityLogExternalFilterItems) => {
  const filterValues = FilterUtils.getExternalFilterValues(externalFilters)

  if (FilterUtils.findEmptyFilter(filterValues)) return EMPTY_SUCCESS_RESPONSE

  const values = { ...filterValues, maxRecords: 200 }
  const queryParams = queryString.stringify(values, { skipNull: true })

  return usingGet(`Trainings/GetTrainingResultsSummary?${queryParams}`)
}
